import { z } from 'zod'

export let amountSchema = z.object({
  charged_amount: z.number().nullable(),
  coinsurance: z.number().nullable(),
  deductible: z.number().nullable(),
  ineligible: z.number().nullable(),
  out_of_pocket: z.number().nullable(),
  ppo_discount: z.number().nullable(),
  total_paid: z.number().nullable(),
  year: z.string()
})

export let amountsSchema = z.array(amountSchema)
